import * as React from 'react';
import {ImageFormatType} from '../../../models/chatChannelModel/message/format';
import {styled} from '../../../utils';
import ChatMessage from '../ChatMessage';

interface ImageMessageProps {
  message: ChatMessage<ImageFormatType>;
}

const Root = styled('img')({
  width: '200px',
  marginLeft: 60,
  marginTop: 20,
  marginBottom: 20,
  '-webkit-transform': 'rotate(90deg)',
  '-moz-transform': 'rotate(90deg)',
  '-o-transform': 'rotate(90deg)',
  '-ms-transform': 'rotate(90deg)',
  transform: 'rotate(90deg)',
  borderRadius: 5
});

export default class ImageMessage extends React.Component<
  ImageMessageProps,
  {}
> {
  public render() {
    const linkImage = this.props.message.format.attachment.payload.url;
    return <Root src={linkImage} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/ChatUI/ImageMessage/ImageMessage.tsx